import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useTranslate } from '@im/react-localization';
import { usePageTitle } from '../../config';
import AdminPricing from './AdminPricing';
import Approvals from './Approvals';
import CreateNewRule from './CreateNewRule';
import EditPricingRule from './CreateNewRule/EditPricingRule';
import Redirect from './Redirect';

export function PricingRoute() {
  const { updatePageTitle } = usePageTitle();
  const translate = useTranslate();
  updatePageTitle(translate('Pricing.PageTitle'));

  return (
    <Routes>
      <Route element={<Redirect />} path="redirect" />
      <Route element={<CreateNewRule />} path="new-rule" />
      <Route element={<EditPricingRule />} path="edit" />
      <Route element={<AdminPricing />} path="approvals" />
      <Route element={<Approvals />} path="admin" />
      <Route element={<Navigate replace to="new-rule" />} path="" />
    </Routes>
  );
}
